import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useClassName } from '../../../../hooks';
import { CollapsibleContext } from '../../Collapsible.context';
import './Container.scss';
export const Container = ({ children }) => {
    const { isOpen } = useContext(CollapsibleContext);
    const containerClass = useClassName({ name: 'collapsible', prefixed: true }, isOpen ? 'open' : 'closed');
    return _jsx("div", { className: containerClass, children: children });
};
